import { useState, useEffect, useContext } from 'react'
import { Loader } from '../../utils/loader';
import { hanldeSortingArray } from '../../utils/sortingByColumn';
import NoDataError from '../../components/NoDataError';
import { Button, Modal, ModalDialog } from 'react-bootstrap';
import Draggable from 'react-draggable';
import { ThemeContext } from '../../layout/BaseLayout';
import * as VendorMasterServices from '../../services/vendorMasterServices';
import { Editor, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

const vendorMasterModalDragModal = (props) => {
	return (
		<Draggable handle=".modal-header">
			<ModalDialog {...props} />
		</Draggable>
	);
};

const VendorMaster = () => {

	const defaultSortingOrderObj = {
		sortingOrder: 'asc',
		upDownArrowColumn: null,
		fieldType: null
	}

	const defaultVendorObj = {
		"vendorId": 0,
		"vendorCode": "",
		"vendorSecretKey": "",
		"vendorAuthKey": "",
		"primaryDomain": "",
		"secondaryDomain": "",
		"accessDomain": "",
		"vendorLogo": "",
		"companyName": "",
		"personName": "",
		"referenceName": "",
		"vendorAddress": "",
		"vendorCity": "",
		"vendorState": "",
		"contactNo": "",
		"emailId": "",
		"website": "",
		"skypeId": "",
		"vendorDescription": "",
		"vendorStatus": true,
		"userName": "",
		"name": "",
		"userPassword": "",
		"userDescription": "",
		"userStatus": true,
	}

	const [vendorsList, setVendorsList] = useState([]);
	const [selectedArr, setSelectedArr] = useState([]);
	const [sortingOrderObj, setSortingOrderObj] = useState({ ...defaultSortingOrderObj });
	const [isLoader, setIsLoader] = useState(false);
	const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
	const [showVendorModal, setShowVendorModal] = useState(false);
	const [vendorMasterObj, setVendorMasterObj] = useState({ ...defaultVendorObj });
	const [isEdit, setIsEdit] = useState(false);
	const [primaryDomainError, setPrimaryDomainError] = useState(false);
	const [companyNameError, setCompanyNameError] = useState(false);
	const [editorState, setEditorState] = useState(EditorState.createEmpty())

	let toast = useContext(ThemeContext);

	const getVendorsList = () => {
		setIsLoader(true);
		VendorMasterServices.getVendorsData().then((res) => {
			setIsLoader(false);
			if (res.isSuccess) {
				setVendorsList(res.data);
			} else {
				setIsLoader(false);
			}
		}).catch(e => {
			setIsLoader(false);
		})
	}

	const onOpenAddModal = () => {
		setShowVendorModal(true);
		setIsEdit(false);
		setVendorMasterObj({ ...defaultVendorObj })
	}

	const onCloseVendorModal = () => {
		setShowVendorModal(false);
		setIsEdit(false);
		setVendorMasterObj({ ...defaultVendorObj });
		setPrimaryDomainError(false);
		setCompanyNameError(false);
	}

	const onSubmitVendorMaster = () => {
		let isValid = true;
		const body = { ...vendorMasterObj }

		if (isEdit) {
			delete body['userName'];
			delete body['name'];
			delete body['userPassword'];
			delete body['userDescription'];
			delete body['userStatus'];
		}

		if (!vendorMasterObj?.primaryDomain || vendorMasterObj?.primaryDomain === "") {
			setPrimaryDomainError(true);
			isValid = false;
		}

		if (!vendorMasterObj?.companyName || vendorMasterObj?.companyName === "") {
			setCompanyNameError(true);
			isValid = false;
		}

		if (isValid) {
			if (!isEdit) {
				setDisableSubmitBtn(true);
				VendorMasterServices.createVendors(body).then((res) => {
					setDisableSubmitBtn(false);
					if (res.isSuccess) {
						setVendorsList([...vendorsList, res.data]);
						toast.success(res?.successMessage);
						setShowVendorModal(false);
					} else {
						toast.error(res?.exception?.message);
						setDisableSubmitBtn(false);
					}
				}).catch(e => {
					setDisableSubmitBtn(false);
				})
			} else {
				VendorMasterServices.updateVendorDetails(body).then((res) => {
					if (res?.isSuccess) {
						let tempVendorArr = [...vendorsList];
						let index = tempVendorArr.findIndex((item) => item?.vendorId === body.vendorId);
						tempVendorArr[index] = res.data;
						setVendorsList([...tempVendorArr]);
						toast.success(res?.successMessage);
						setShowVendorModal(false);
					} else {
						toast.error(res?.exception?.message);
						setDisableSubmitBtn(false);
					}
				}).catch(e => {
					setDisableSubmitBtn(false);
				})
			}
		}
	}

	const onEditPackageData = (item) => {
		VendorMasterServices.getVendorDetailsById(item).then((res) => {
			if (res.isSuccess) {
				setIsEdit(true);
				setVendorMasterObj(res.data);
				setShowVendorModal(true);
			} else {
				toast.error(res?.exception?.message);
			}
		})
	}

	const onImageChoose = (event) => {
		if (event.target.files[0].size < 51200) {
			let file = event.target.files[0];
			let name = event.target.name
			let value = event.target.value;

			if (["jpg", "jpeg", "png", "gif"].includes(value.split(".")[value.split(".").length - 1])) {

				let reader = new FileReader();

				reader.onloadend = () => {
					let updatedta = { ...vendorMasterObj }
					updatedta[name] = reader.result
					setVendorMasterObj({ ...updatedta })
				}
				reader.readAsDataURL(file);

			} else {
				toast.error("Only Image file formats - jpg, jpeg, png, gif supported !!!")
				document.getElementById("vendorLogo").value = ""
			}

		} else {
			toast.error("Logo Size must be lower than 50 KB !!!")
			document.getElementById("vendorLogo").value = ""
		}
	}

	const updateVendorField = (val, fld) => {
		let dta = vendorMasterObj;
		dta[fld] = val;
		setVendorMasterObj({ ...dta });
	}

	const handleEditorChange = (state) => {
		const htmlContent = draftToHtml(convertToRaw(state.getCurrentContent()));
		setEditorState(state);
		updateVendorField(htmlContent, "vendorDescription");
	};

	const onSelectionRow = (item) => {
		if (!!vendorsList && vendorsList.length > 0) {
			const selectedRow = vendorsList.map((elem) => { return elem.vendorId }).indexOf(item.vendorId);
			if (selectedRow > -1) {
				setSelectedArr([vendorsList[selectedRow]]);
			}
		}
	}

	const checkItem = (item) => {
		const checkData = !!selectedArr && selectedArr.some((val) => val?.vendorId === item?.vendorId);
		return checkData;
	}

	const creatingSortingArrFn = (field, type) => {
		let order = sortingOrderObj.sortingOrder;
		if (field === sortingOrderObj.upDownArrowColumn) {
			order = order === 'asc' ? 'desc' : 'asc';
			setSelectedArr([]);
		} else {
			order = 'asc';
			setSelectedArr([]);
		}
		setSortingOrderObj({ sortingOrder: order, upDownArrowColumn: field, fieldType: type })
	}


	useEffect(() => {
		if (!!sortingOrderObj && sortingOrderObj.upDownArrowColumn !== '') {
			let sortedArrayByColumn = [...vendorsList]
			sortedArrayByColumn = hanldeSortingArray(sortedArrayByColumn, sortingOrderObj.upDownArrowColumn, sortingOrderObj.fieldType, sortingOrderObj.sortingOrder)
			setVendorsList(sortedArrayByColumn);
		}
	}, [sortingOrderObj])

	useEffect(() => {
		getVendorsList();
	}, [])

	return (
		<div id='tabs'>
			{(!!isLoader && isLoader) && <Loader />}
			<div className="maintitle-box">
				<div className="w-50 d-inline-block">
					<h2 className="maintitle "><img className="main-title-img" src={"/images/svg/vendor.svg"} alt="" />Vendor Master</h2>
				</div>
				<div className="w-50 d-inline-block">
					<div className="float-end ">
						<div className="d-inline-block mr-3"><i id="vendorRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary"
							onClick={() => { getVendorsList(); }}></i>
						</div>
						<button className="addnewbtn mb-0" onClick={() => { onOpenAddModal(); }}>
							<i className="fa-solid fa-circle-plus mr-2"></i>Add
						</button>
					</div>
				</div>
			</div>
			<div className="thead-fixed">
				<table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc">
					<thead>
						<tr className="
						">
							<th className=" srn-width">Sr</th>
							<th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'vendorCode' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('vendorCode', 'Text')}>Vendor Code</th>
							<th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'companyName' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('companyName', 'Text')}>Company name</th>
							<th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'primaryDomain' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('primaryDomain', 'Text')}>Domain</th>
							<th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'vendorAuthKey' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('vendorAuthKey', 'Text')}>Auth Key</th>
							<th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'vendorStatus' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('vendorStatus', 'Status')}>Status</th>
						</tr>
					</thead>
					<tbody>
						{(!!vendorsList && vendorsList.length > 0) ? vendorsList.map((item, i) => {
							return (
								<tr key={"vendorsList" + i} onDoubleClick={() => { onEditPackageData(item.vendorId) }} onClick={() => onSelectionRow(item)}
									className={`${checkItem(item) ? 'selected-tr' : ''} `}>
									<td className="">{i + 1}</td>
									<td className="">{item.vendorCode}</td>
									<td className="">{item.companyName}</td>
									<td className="">{item.primaryDomain}</td>
									<td className="">{item.vendorAuthKey}</td>
									<td className="">{(!!item.vendorStatus && item.vendorStatus) ? 'Active' : 'InActive'}</td>
								</tr>
							)
						}) : <NoDataError colspn={6} />}
					</tbody>
				</table>
			</div>
			<div className="login-popup">
				<Modal
					className="login licence-modules"
					show={showVendorModal}
					onHide={() => onCloseVendorModal()}
					backdrop="static"
					dialogAs={vendorMasterModalDragModal}
					animation={false}
					size="md"
					centered
				>
					<Modal.Header closeButton style={{ border: "none" }}>
						<Modal.Title className="w-100">
							Vendor Master
							<div className="btn-help d-inline-block float-right">

							</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{ display: "flex", flexDirection: "column" }}>
						<div className="prl">
							<table border="0" cellSpacing="0" cellPadding="0" className="w-100 font11 mt-0" >
								{isEdit ?
									<>
										<tr>
											<td className="symbolrw-24 text-right font11 licence150">Vendor Code :</td>
											<td className={`licence200`}>
												<input
													type="text"
													name="vendorCode"
													className="font11 h20 inputborder mb-2 ml-2 p-1 w-100"
													value={vendorMasterObj?.vendorCode}
													onChange={(e) => { updateVendorField(e.target.value, "vendorCode") }}
													autocomplete="off"
													autoFocus
												/>
											</td>
											<td className="licence50" >&nbsp;</td>
											<td className="licence150 d-inline-block symbolrw-24 text-right font11">Vendor Secret Key :</td>
											<td className="licence200 d-inline-block symbolrw-25">
												<input
													type="text"
													name="vendorSecretKey"
													className="inputborder font11 w-100 mb-2 ml-2 h20"
													value={vendorMasterObj?.vendorSecretKey}
													onChange={(e) => { updateVendorField(e.target.value, "vendorSecretKey") }}
													autocomplete="off"
												/>
											</td>
										</tr>
										<tr>
											<td className="symbolrw-24 text-right font11 licence150">Primary Domain :</td>
											<td className={`licence200 ${primaryDomainError && 'error'}`}>
												<input
													type="text"
													name="primaryDomain"
													className="inputborder font11 w-100 mb-2 ml-2 h20"
													value={vendorMasterObj?.primaryDomain}
													onChange={(e) => { updateVendorField(e.target.value, "primaryDomain"); }}
													autocomplete="off"
												/>
											</td>
											<td className="licence50" >&nbsp;</td>
											<td className="licence150 d-inline-block symbolrw-24 text-right font11">Secondary Domain :</td>
											<td className="licence200 d-inline-block symbolrw-25">
												<input
													type="text"
													name="secondaryDomain"
													className="inputborder font11 w-100 mb-2 ml-2 h20"
													value={vendorMasterObj?.secondaryDomain}
													onChange={(e) => { updateVendorField(e.target.value, "secondaryDomain") }}
													autocomplete="off"
												/>
											</td>
										</tr>
										<tr>
											<td className="symbolrw-24 text-right font11 licence150">Vendor Auth Key :</td>
											<td className={`licence200`}>
												<input
													type="text"
													name="vendorAuthKey"
													className="inputborder font11 w-100 mb-2 ml-2 h20"
													value={vendorMasterObj?.vendorAuthKey}
													onChange={(e) => { updateVendorField(e.target.value, "vendorAuthKey") }}
													autocomplete="off"
												/>
											</td>
											<td className="licence50" >&nbsp;</td>
											<td className="licence150 d-inline-block symbolrw-24 text-right font11">Access Domain :</td>
											<td className="licence200 d-inline-block symbolrw-25">
												<input
													type="text"
													name="accessDomain"
													className="inputborder font11 w-100 mb-2 ml-2 h20"
													value={vendorMasterObj?.accessDomain}
													onChange={(e) => { updateVendorField(e.target.value, "accessDomain"); }}
													autocomplete="off"
												/>
											</td>
										</tr>
									</>
									:
									<>
										<tr>
											<td className="symbolrw-24 text-right font11 licence150">Vendor Code :</td>
											<td className={`licence200`}>
												<input
													type="text"
													name="vendorCode"
													className="font11 h20 inputborder mb-2 ml-2 p-1 w-100"
													value={vendorMasterObj?.vendorCode}
													onChange={(e) => { updateVendorField(e.target.value, "vendorCode") }}
													autocomplete="off"
													autoFocus
												/>
											</td>
											<td className="licence50" >&nbsp;</td>
											<td className="symbolrw-24 text-right font11 licence150">Primary Domain :</td>
											<td className={`licence200 ${primaryDomainError && 'error'}`}>
												<input
													type="text"
													name="primaryDomain"
													className="inputborder font11 w-100 mb-2 ml-2 h20"
													value={vendorMasterObj?.primaryDomain}
													onChange={(e) => { updateVendorField(e.target.value, "primaryDomain"); }}
													autocomplete="off"
												/>
											</td>
										</tr>
										<tr>
											<td className="symbolrw-24 text-right font11 licence150">Secondary Domain :</td>
											<td className="licence200">
												<input
													type="text"
													name="secondaryDomain"
													className="inputborder font11 w-100 mb-2 ml-2 h20"
													value={vendorMasterObj?.secondaryDomain}
													onChange={(e) => { updateVendorField(e.target.value, "secondaryDomain") }}
													autocomplete="off"
												/>
											</td>
											<td className="licence50" >&nbsp;</td>
											<td className="licence150 d-inline-block symbolrw-24 text-right font11">Access Domain :</td>
											<td className="licence200">
												<input
													type="text"
													name="accessDomain"
													className="inputborder font11 w-100 mb-2 ml-2 h20"
													value={vendorMasterObj?.accessDomain}
													onChange={(e) => { updateVendorField(e.target.value, "accessDomain"); }}
													autocomplete="off"
												/>
											</td>
										</tr>
									</>
								}

								{/* <tr>
									<td className="symbolrw-24 text-right font11 licence150">Vendor Description :</td>
									<td className={`licence200`}>
										<input
											type="text"
											name="vendorDescription"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.vendorDescription}
											onChange={(e) => { updateVendorField(e.target.value, "vendorDescription") }}
											autocomplete="off"
										/>
									</td>
									<td className="licence50" colSpan={3}>&nbsp;</td>
								</tr> */}
								<tr>
									<td className="symbolrw-24 text-right font11 licence150 align-baseline">Vendor Description :</td>
									<td colSpan={4} className={``}>
										<Editor
											editorState={editorState}
											onEditorStateChange={handleEditorChange}
											toolbarClassName="toolbarClassName"
											wrapperClassName="wrapperClassName wrap121212"
											editorClassName="editorClassName"
											toolbar={{
												options: ['inline', 'fontSize', 'colorPicker', 'emoji', 'history'],
											}}
										/>
									</td>
								</tr>
							</table>

							<hr></hr>
							{/* License Information START */}
							<table border="0" cellSpacing="0" cellPadding="0" className="w-100 font11 mt-0" >
								<tr>
									<td className="text-highlight" colSpan={5}>Vendor Company Information</td>
								</tr>
								<tr>
									<td className="symbolrw-24 text-right font11 licence150">Company name :</td>
									<td className={`licence200 ${companyNameError && 'error'}`}>
										<input
											type="text"
											name="companyName"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.companyName}
											onChange={(e) => { updateVendorField(e.target.value, "companyName"); }}
											autocomplete="off"
										/>
									</td>
									<td className="licence50" >&nbsp;</td>
									<td className="licence150 d-inline-block symbolrw-24 text-right font11">Person name :</td>
									<td className="licence200 d-inline-block symbolrw-25">
										<input
											type="text"
											name="personName"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.personName}
											onChange={(e) => { updateVendorField(e.target.value, "personName") }}
											autocomplete="off"
										/>
									</td>
								</tr>
								<tr>
									<td className="symbolrw-24 text-right font11 licence150">Reference name :</td>
									<td className="licence200">
										<input
											type="text"
											name="referenceName"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.referenceName}
											onChange={(e) => { updateVendorField(e.target.value, "referenceName") }}
											autocomplete="off"
										/>
									</td>
									<td className="licence50" >&nbsp;</td>
									<td className="licence150 d-inline-block symbolrw-24 text-right font11">Vendor Address :</td>
									<td className="licence200 d-inline-block symbolrw-25">
										<input
											type="text"
											name="vendorAddress"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.vendorAddress}
											onChange={(e) => { updateVendorField(e.target.value, "vendorAddress") }}
											autocomplete="off"
										/>
									</td>
								</tr>
								<tr>
									<td className="symbolrw-24 text-right font11 licence150">Vendor City :</td>
									<td className="licence200">
										<input
											type="text"
											name="vendorCity"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.vendorCity}
											onChange={(e) => { updateVendorField(e.target.value, "vendorCity") }}
											autocomplete="off"
										/>
									</td>
									<td className="licence50" >&nbsp;</td>
									<td className="licence150 d-inline-block symbolrw-24 text-right font11">Vendor State :</td>
									<td className="licence200 d-inline-block symbolrw-25">
										<input
											type="text"
											name="vendorState"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.vendorState}
											onChange={(e) => { updateVendorField(e.target.value, "vendorState") }}
											autocomplete="off"
										/>
									</td>
								</tr>
								<tr>
									<td className="symbolrw-24 text-right font11 licence150">contactNo :</td>
									<td className="licence200">
										<input
											type="text"
											name="contactNo"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.contactNo}
											onChange={(e) => { updateVendorField(e.target.value, "contactNo") }}
											autocomplete="off"
										/>
									</td>
									<td className="licence50" >&nbsp;</td>
									<td className="licence150 d-inline-block symbolrw-24 text-right font11">Email Id :</td>
									<td className="licence200 d-inline-block symbolrw-25">
										<input
											type="text"
											name="emailId"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.emailId}
											onChange={(e) => { updateVendorField(e.target.value, "emailId") }}
											autocomplete="off"
										/>
									</td>
								</tr>
								<tr>
									<td className="symbolrw-24 text-right font11 licence150">Website :</td>
									<td className="licence200">
										<input
											type="text"
											name="website"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.website}
											onChange={(e) => { updateVendorField(e.target.value, "website") }}
											autocomplete="off"
										/>
									</td>
									<td className="licence50" >&nbsp;</td>
									<td className="licence150 d-inline-block symbolrw-24 text-right font11">SkypeId :</td>
									<td className="licence200 d-inline-block symbolrw-25">
										<input
											type="text"
											name="skypeId"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.skypeId}
											onChange={(e) => { updateVendorField(e.target.value, "skypeId") }}
											autocomplete="off"
										/>
									</td>
								</tr>
								<tr>
									<td className="symbolrw-24 text-right font11 licence150">Company Desc :</td>
									<td className="licence200">
										<input
											type="text"
											name="companyDescription"
											className="inputborder font11 w-100 mb-2 ml-2 h20"
											value={vendorMasterObj?.companyDescription}
											onChange={(e) => { updateVendorField(e.target.value, "companyDescription") }}
											autocomplete="off"
										/>
									</td>
									<td className="licence50" >&nbsp;</td>
									<td className="licence150 d-inline-block symbolrw-24 text-right font11">Vendor Status :</td>
									<td className="licence200 d-inline-block symbolrw-25">
										<div className="d-inline-block">
											<div className="form-check-inline mb-2 mr-4 width-25">
												<label className="form-check-label marginleft25group">
													<input
														type="radio"
														className="form-check-input mt-1"
														name="vendorStatus"
														onChange={(e) => { updateVendorField(true, "vendorStatus") }}
														checked={vendorMasterObj?.vendorStatus} />Yes
												</label>
											</div>
											<div className="form-check-inline width-25">
												<label className="form-check-label ml-3">
													<input
														type="radio"
														className="form-check-input mt-1"
														name="vendorStatus"
														onChange={(e) => { updateVendorField(false, "vendorStatus") }}
														checked={!vendorMasterObj?.vendorStatus} />No
												</label>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<td className="symbolrw-24 text-right font11 licence150">
										<div className="imgpreview">
											<img alt="" src={vendorMasterObj?.vendorLogo} />
										</div>
									</td>
									<td className="licence200">
										<div className="form-group d-inline-block ml-2">
											<label htmlFor="vendorLogo" className="form-label">Vendor Logo :</label>
											<input
												type="file"
												className="form-control"
												name="vendorLogo"
												id="vendorLogo"
												onChange={(e) => { onImageChoose(e) }}
												accept="image/*"
											/>
										</div>
									</td>
									<td className="licence50" >&nbsp;</td>
								</tr>
							</table>
							<hr></hr>
							{/* License Information END */}
							{/* License Admin User Details START */}
							{!isEdit &&
								<table border="0" cellSpacing="0" cellPadding="0" className="w-100 font11 mt-0" >
									<tr>
										<td className="text-highlight" colSpan={5}>Vendor Admin User Details</td>
									</tr>
									<tr>
										<td className="symbolrw-24 text-right font11 licence150">userName / LoginId :</td>
										<td className="licence200">
											<input
												type="text"
												name="userName"
												className="inputborder font11 w-100 mb-2 ml-2 h20"
												value={vendorMasterObj?.userName}
												onChange={(e) => { updateVendorField(e.target.value, "userName") }}
												autocomplete="off"
											/>
										</td>
										<td className="licence50" >&nbsp;</td>
										<td className="licence150 d-inline-block symbolrw-24 text-right font11">name :</td>
										<td className="licence200 d-inline-block symbolrw-25">
											<input
												type="text"
												name="name"
												className="inputborder font11 w-100 mb-2 ml-2 h20"
												value={vendorMasterObj?.name}
												onChange={(e) => updateVendorField(e.target.value, "name")}
												autocomplete="off"
											/>
										</td>
									</tr>
									<tr>
										<td className="symbolrw-24 text-right font11 licence150">User Role :</td>
										<td className="licence200">
											<input
												type="text"
												name="userRole"
												className="inputborder font11 w-100 mb-2 ml-2 h20"
												value="Admin"
												disabled
											/>
										</td>
										<td className="licence50" >&nbsp;</td>
										<td className="licence150 d-inline-block symbolrw-24 text-right font11">User Password :</td>
										<td className="licence200 d-inline-block symbolrw-25">
											<input
												type="text"
												name="userPassword"
												className="inputborder font11 w-100 mb-2 ml-2 h20"
												value={vendorMasterObj?.userPassword}
												onChange={(e) => updateVendorField(e.target.value, "userPassword")}
												autocomplete="off"
											/>
										</td>
									</tr>
									<tr>
										<td className="symbolrw-24 text-right font11 licence150">User Description :</td>
										<td className="licence200">
											<input
												type="text"
												name="userDescription"
												className="inputborder font11 w-100 mb-2 ml-2 h20"
												value={vendorMasterObj?.userDescription}
												onChange={(e) => updateVendorField(e.target.value, "userDescription")}
												autocomplete="off"
											/>
										</td>
										<td className="licence50" >&nbsp;</td>
										<td className="licence150 d-inline-block symbolrw-24 text-right font11">User Status :</td>
										<td className="licence200 d-inline-block symbolrw-25">
											<div className="d-inline-block">
												<div className="form-check-inline mb-2 mr-4 width-25">
													<label className="form-check-label marginleft25group">
														<input
															type="radio"
															className="form-check-input mt-1"
															name="userStatus"
															checked={vendorMasterObj?.userStatus}
															onChange={(e) => updateVendorField(true, "userStatus")}
														/>Yes
													</label>
												</div>
												<div className="form-check-inline width-25">
													<label className="form-check-label ml-3">
														<input
															type="radio"
															className="form-check-input mt-1"
															name="userStatus"
															checked={!vendorMasterObj?.userStatus}
															onChange={(e) => updateVendorField(false, "userStatus")}
														/>No
													</label>
												</div>
											</div>
										</td>
									</tr>
								</table>
							}
							{/* License Admin User Details END */}
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div>
							<div className="w-100 text-right p-1">
								<Button className="btnmain mr-3" onClick={() => { onSubmitVendorMaster() }} disabled={disableSubmitBtn}>
									{disableSubmitBtn && <i className="fa fa-spinner fa-spin mr-2"></i>}Submit
								</Button>
								<Button onClick={() => onCloseVendorModal()} className="btnmain-danger">
									Cancel
								</Button>
							</div>
						</div>
					</Modal.Footer>
				</Modal>
			</div>
		</div>
	)
}

export default VendorMaster